import * as connectedDomains from '@wix/auto_sdk_domains_connected-domains';
import * as connectedDomainSetupInfo from '@wix/auto_sdk_domains_connected-domain-setup-info';
import * as dnsPropagation from '@wix/auto_sdk_domains_dns-propagation';
import * as domainDns from '@wix/auto_sdk_domains_domain-dns';
import * as domainAvailability from '@wix/auto_sdk_domains_domain-availability';
import * as domainSuggestions from '@wix/auto_sdk_domains_domain-suggestions';

export {
  connectedDomains,
  connectedDomainSetupInfo,
  dnsPropagation,
  domainDns,
  domainAvailability,
  domainSuggestions,
};
